/* Memori theme JS. GSAP is optional (motion setting); everything degrades to plain links and forms. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const M = window.memori || {};
  const R = window.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root_url: '/' };

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Sound: tiny synthesised clicks, only after a tap, quiet ---------- */
  let ac = null;
  const audio = () => { if (!ac) { const C = window.AudioContext || window.webkitAudioContext; if (C) ac = new C(); } if (ac && ac.state === 'suspended') ac.resume(); return ac; };
  function tone(freq, dur, { type = 'sine', vol = 0.05, at = 0, slide = 0 } = {}) {
    const a = audio(); if (!a) return;
    const t = a.currentTime + at, o = a.createOscillator(), g = a.createGain();
    o.type = type; o.frequency.setValueAtTime(freq, t);
    if (slide) o.frequency.exponentialRampToValueAtTime(freq * slide, t + dur);
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol, t + 0.008); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g).connect(a.destination); o.start(t); o.stop(t + dur + 0.02);
  }
  const sfx = {
    tick: () => M.sfx && tone(1800, 0.05, { type: 'triangle', vol: 0.025 }),
    pop: () => M.sfx && (tone(520, 0.12, { vol: 0.05, slide: 1.9 })),
    press: () => M.sfx && (tone(140, 0.09, { type: 'triangle', vol: 0.08, slide: 0.6 }), tone(2400, 0.03, { type: 'square', vol: 0.012 })),
    chime: () => M.sfx && [784, 988, 1319].forEach((f, i) => tone(f, 0.5, { vol: 0.035, at: i * 0.09 }))
  };
  window.memoriSfx = sfx;

  /* ---------- Money ---------- */
  // "With light" is lit; "Without light" / "No light" is not.
  const litName = (t) => /light|glow|led/i.test(t || '') && !/no light|without|non[- ]?lit/i.test(t || '');
  function money(cents) {
    const fmt = M.moneyFormat || '₹{{amount}}';
    const n = (cents / 100);
    const withDelims = (num, dec, th = ',', d = '.') => {
      const parts = num.toFixed(dec).split('.');
      // Indian grouping: 1,23,456
      let int = parts[0];
      const last3 = int.slice(-3), rest = int.slice(0, -3);
      int = rest ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, th) + th + last3 : last3;
      return parts[1] ? int + d + parts[1] : int;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return withDelims(n, 0);
      if (k === 'amount_with_comma_separator') return withDelims(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withDelims(n, 0, '.', ',');
      return withDelims(n, 2).replace(/\.00$/, '');
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => (t.hidden = true), 3200);
  }

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(() => d.classList.add('is-open'));
    document.body.classList.add('is-locked');
    const f = $('[data-autofocus], button, a, input', d.querySelector('.drawer__panel') || d);
    setTimeout(() => f && f.focus({ preventScroll: true }), 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    setTimeout(() => { if (!d.classList.contains('is-open')) d.hidden = true; }, 450);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.open); return; }
    const closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer, .search-modal')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .search-modal.is-open').forEach(closeDrawer);
  });
  $$('.search-modal').forEach((m) => m.addEventListener('click', (e) => { if (e.target === m) closeDrawer(m); }));

  /* ---------- Header shadow ---------- */
  const hw = $('.header-wrap');
  if (hw) {
    // One cheap check per frame at most: shadow after 8px, hide on scroll down past 300px, show on scroll up.
    let lastY = window.scrollY, ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      hw.classList.toggle('is-scrolled', y > 8);
      // Ignore tiny moves and the bounce at the top/bottom, so the header doesn't flicker.
      const d = y - lastY, atEnd = y + innerHeight >= document.documentElement.scrollHeight - 4;
      if (!document.body.classList.contains('is-locked') && !atEnd && Math.abs(d) > 6) { hw.classList.toggle('is-hidden', y > 300 && d > 0); lastY = y; }
      if (y <= 300) { hw.classList.remove('is-hidden'); lastY = y; }
      ticking = false;
    };
    onScroll(); window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  }

  /* ---------- Announcement bar: smooth scrolling line, or one message at a time, + countdowns ---------- */
  $$('[data-announce]').forEach((bar) => {
    const mode = bar.dataset.mode || 'fade';
    const track = $('.announce__track', bar);
    const group = $('.announce__group', bar);
    const still = mode === 'static' || document.documentElement.classList.contains('no-motion') || matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Countdowns: re-query every tick so cloned copies stay in step; an expired message leaves every copy.
    const fmt = (left) => {
      const d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, mi = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
      return (d ? d + 'd ' : '') + String(h).padStart(2, '0') + 'h ' + String(mi).padStart(2, '0') + 'm ' + String(s).padStart(2, '0') + 's';
    };
    let build = () => {};
    const tick = () => {
      let removed = false;
      $$('.announce__msg[data-deadline]', bar).forEach((m) => {
        const end = new Date(m.dataset.deadline).getTime(); if (isNaN(end)) return;
        const left = end - Date.now();
        if (left <= 0) { const sep = m.nextElementSibling; if (sep && sep.classList.contains('announce__sep')) sep.remove(); m.remove(); removed = true; return; }
        const c = $('.announce__count', m); if (c) c.textContent = fmt(left);
      });
      if (removed) build();
    };
    tick(); setInterval(tick, 1000);

    if (mode === 'scroll' && !still && track && group) {
      // Repeat the group until one half is wider than the bar, then copy that half once and slide by -50%: no gap, no jump.
      build = () => {
        $$('[data-clone]', track).forEach((n) => n.remove());
        if (!$('.announce__msg', group)) { bar.hidden = true; return; }
        const vw = bar.clientWidth || innerWidth;
        const one = group.scrollWidth || 1;
        const reps = Math.max(1, Math.ceil(vw / one));
        const mk = () => { const c = group.cloneNode(true); c.setAttribute('data-clone', ''); c.setAttribute('aria-hidden', 'true'); $$('a', c).forEach((x) => x.setAttribute('tabindex', '-1')); $$('[data-shopify-editor-block]', c).forEach((x) => x.removeAttribute('data-shopify-editor-block')); return c; };
        for (let k = 1; k < reps * 2; k++) track.appendChild(mk());
        const dist = one * reps;
        track.style.setProperty('--announce-dist', dist + 'px');
        track.style.setProperty('--announce-dur', (dist / Math.max(10, Number(bar.dataset.pps || 45))).toFixed(2) + 's');
        bar.classList.add('is-running');
      };
      build();
      let rw; addEventListener('resize', () => { clearTimeout(rw); rw = setTimeout(build, 200); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
      return;
    }
    if (mode === 'scroll' || mode === 'static') { bar.classList.add('is-static'); return; }
    // One at a time (fade)
    let i = 0;
    const live = () => $$('.announce__msg', bar);
    const show = () => { const l = live(); if (!l.length) { bar.hidden = true; return; } l.forEach((m, k) => m.classList.toggle('is-active', k === i % l.length)); };
    show();
    if (live().length > 1 && !still) setInterval(() => { i++; show(); }, Number(bar.dataset.speed || 5) * 1000);
  });

  /* ---------- Product grid filter buttons (by product tag) ---------- */
  $$('[data-pgrid]').forEach((sec) => {
    const chips = $$('[data-pgrid-tag]', sec);
    const more0 = $('[data-pgrid-more]', sec);
    if (!chips.length) { if (more0) more0.addEventListener('click', () => { sec.classList.add('is-open'); more0.parentElement.remove(); }); return; }
    const norm = (v) => String(v).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-');
    const items = $$('.pgrid__item', sec).map((it) => [it, (it.dataset.tags || '').split('|').map(norm)]);
    chips.forEach((c) => c.addEventListener('click', () => {
      const t = norm(c.dataset.pgridTag || '');
      chips.forEach((x) => x.setAttribute('aria-pressed', String(x === c)));
      items.forEach(([it, tags]) => { it.hidden = !!t && !tags.includes(t); });
      sec.classList.toggle('is-filtered', !!t);
    }));
    const more = $('[data-pgrid-more]', sec);
    if (more) more.addEventListener('click', () => { sec.classList.add('is-open'); more.parentElement.remove(); });
  });

  /* ---------- Rails ---------- */
  $$('[data-rail-prev], [data-rail-next]').forEach((b) => b.addEventListener('click', () => {
    const rail = document.getElementById(b.dataset.railPrev || b.dataset.railNext); if (!rail) return;
    const dir = b.hasAttribute('data-rail-next') ? 1 : -1;
    rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
  }));

  /* ---------- Motion: one soft rise as blocks come into view ----------
     Fail-safe: everything is visible by default. Only blocks below the fold are hidden, and they come back
     when they enter the screen, or on the next scroll check if the observer ever misses them. No GSAP. */
  const G = window.gsap;
  if ('IntersectionObserver' in window && !reduced && !document.documentElement.classList.contains('no-motion')) {
    const CARD = '.gift-for__card, .model, .tile, .addon-card, .pcard';
    const items = $$('.reveal, ' + CARD).filter((el) => !el.parentElement.closest('.reveal') && el.getBoundingClientRect().top > innerHeight * 0.9);
    const show = (el) => { if (el.classList.contains('is-pending')) { el.classList.remove('is-pending'); el.classList.add('is-in'); } };
    items.forEach((el) => {
      if (el.matches(CARD)) { const k = [...el.parentElement.children].indexOf(el); if (k > 0) el.style.animationDelay = (k % 3) * 40 + 'ms'; }
      el.classList.add('is-pending');
    });
    const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } }), { rootMargin: '0px 0px 12% 0px' });
    items.forEach((el) => io.observe(el));
    let t = 0;
    const sweep = () => { t = 0; items.forEach((el) => { if (el.getBoundingClientRect().top < innerHeight) show(el); }); };
    addEventListener('scroll', () => { if (!t) t = setTimeout(sweep, 120); }, { passive: true });
    addEventListener('load', () => setTimeout(sweep, 300));
  }

  /* ---------- 3D magnet: tilt, press to play, light switch ---------- */
  let tune = null, tuneSrc = null, analyser = null, playingMag = null;
  function stopTune() { if (tune) tune.pause(); }
  const initMag3d = (scope) => $$('[data-mag3d]', scope).forEach((mag) => {
    const tilt = $('.mag3d__tilt', mag), btn = $('[data-mag3d-play]', mag), hint = $('[data-mag3d-hint]', mag);
    const bars = $$('[data-mag3d-eq] i', mag), notes = $('[data-mag3d-notes]', mag), light = $('[data-mag3d-light]', mag);
    // Gentle idle pose, pointer tilt on devices that hover.
    const set = (x, y) => { mag.style.setProperty('--ty', `${x}deg`); mag.style.setProperty('--tx', `${y}deg`); mag.style.setProperty('--sx', x * -3); };
    let rest = [-18, 5]; // gentle turn: the Type-C side shows without stretching the photo
    set(...rest);
    // Other code (the scroll story) can turn the magnet and switch its light.
    mag.addEventListener('mag:pose', (e) => {
      const d = e.detail || {};
      rest = [d.x ?? rest[0], d.y ?? rest[1]]; set(...rest);
      if ('lit' in d) mag.classList.toggle('is-lit', !!d.lit);
      mag.classList.toggle('is-hinting', !!d.hint);
    });
    if (!reduced && matchMedia('(hover: hover)').matches) {
      mag.addEventListener('pointermove', (e) => {
        const r = tilt.getBoundingClientRect();
        set(((e.clientX - r.left) / r.width - 0.5) * 30, -((e.clientY - r.top) / r.height - 0.5) * 22);
      });
      mag.addEventListener('pointerleave', () => set(...rest));
    }
    if (G && !reduced && mag.getBoundingClientRect().top > innerHeight * 0.8) G.fromTo(tilt, { rotateY: -40, y: 30, opacity: 0 }, { rotateY: 0, y: 0, opacity: 1, duration: 1.6, ease: 'expo.out', clearProps: 'transform,opacity', scrollTrigger: { trigger: mag, start: 'top 85%', once: true } });

    let raf = 0, noteTimer = 0;
    function loop() {
      if (analyser) {
        const d = new Uint8Array(analyser.frequencyBinCount); analyser.getByteFrequencyData(d);
        bars.forEach((b, i) => { b.style.height = `${4 + (d[2 + i * 3] / 255) * 18}px`; });
      }
      raf = requestAnimationFrame(loop);
    }
    function spawnNote() {
      if (!notes || reduced) return;
      const n = document.createElement('span'); n.className = 'mag3d__note';
      n.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 17.5V5l10-2v12.5"/><circle cx="6.5" cy="17.5" r="2.5"/><circle cx="16.5" cy="15.5" r="2.5"/></svg>';
      notes.appendChild(n);
      const dx = (Math.random() - 0.5) * 160;
      const anim = n.animate([{ transform: 'translate(-50%,0) scale(.6)', opacity: 0 }, { opacity: 1, offset: 0.15 }, { transform: `translate(calc(-50% + ${dx}px), -${180 + Math.random() * 80}px) rotate(${dx / 6}deg) scale(1)`, opacity: 0 }], { duration: 2600, easing: 'cubic-bezier(.22,1,.36,1)' });
      anim.onfinish = () => n.remove();
    }
    function setPlaying(on) {
      mag.classList.toggle('is-playing', on);
      btn.setAttribute('aria-pressed', on);
      if (hint) hint.textContent = on ? (hint.dataset.on || 'Playing a sample. Tap to stop.') : (hint.dataset.off || 'Tap the button to hear it');
      cancelAnimationFrame(raf); clearInterval(noteTimer);
      if (on) { loop(); spawnNote(); noteTimer = setInterval(spawnNote, 700); } else bars.forEach((b) => (b.style.height = '4px'));
    }
    btn.addEventListener('click', () => {
      sfx.press(); mag.classList.add('has-played');
      btn.classList.add('is-pressed'); setTimeout(() => btn.classList.remove('is-pressed'), 160);
      if (!tune) {
        tune = new Audio(M.tune); tune.crossOrigin = 'anonymous'; tune.preload = 'auto';
        try { const a = audio(); tuneSrc = a.createMediaElementSource(tune); analyser = a.createAnalyser(); analyser.fftSize = 64; tuneSrc.connect(analyser).connect(a.destination); } catch (e) { analyser = null; }
      }
      if (playingMag === mag && !tune.paused) { stopTune(); return; }
      if (playingMag && playingMag !== mag) playingMag.dispatchEvent(new Event('mag:stop'));
      playingMag = mag; tune.currentTime = 0;
      tune.onended = tune.onpause = () => { if (playingMag === mag) setPlaying(false); };
      tune.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    });
    mag.addEventListener('mag:stop', () => setPlaying(false));
    light && light.addEventListener('click', () => {
      const on = light.getAttribute('aria-pressed') !== 'true';
      light.setAttribute('aria-pressed', on); mag.classList.toggle('is-lit', on); sfx.tick();
    });
  });
  initMag3d(document);
  /* ---------- Scroll story: each chapter that reaches the middle of the screen poses the pinned magnet ---------- */
  $$('[data-story]').forEach((sec) => {
    const mag = $('[data-mag3d]', sec), steps = $$('.story__step', sec), dots = $$('.story__dots span', sec), shots = $$('.story__shot', sec);
    if (!steps.length) return;
    let cur = -1;
    const go = (i) => {
      if (i === cur) return; cur = i;
      steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      shots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      sec.style.setProperty('--story-p', ((i + 1) / steps.length).toFixed(3));
      const st = steps[i], [x, y] = st.dataset.pose.split(',').map(Number);
      if (mag) mag.dispatchEvent(new CustomEvent('mag:pose', { detail: { x, y, lit: st.dataset.lit === 'true', hint: st.dataset.hint === 'true' } }));
      if (st.dataset.lit === 'true') sfx.tick();
    };
    go(0);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) go(steps.indexOf(en.target)); }), { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach((s) => io.observe(s));
    }
  });

  // Stop playback when the magnet scrolls away.
  if ('IntersectionObserver' in window) {
    const so = new IntersectionObserver((es) => es.forEach((en) => { if (!en.isIntersecting && en.target === playingMag) stopTune(); }));
    $$('[data-mag3d]').forEach((m) => so.observe(m));
  }

  /* ---------- Predictive search ---------- */
  $$('[data-predictive]').forEach((wrap) => {
    const input = $('input[type="search"]', wrap), out = $('.search-results', wrap);
    let t;
    input && input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`${R.root_url.replace(/\/$/, '')}/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6`);
          const j = await r.json();
          const p = (j.resources.results.products || []), c = (j.resources.results.collections || []);
          const e = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]);
          out.innerHTML = [...c.map((x) => `<a href="${e(x.url)}"><span class="h4">${e(x.title)}</span></a>`),
            ...p.map((x) => `<a href="${e(x.url)}">${x.image ? `<img src="${e(x.image)}" alt="" width="56" height="56" loading="lazy">` : ''}<span><b>${e(x.title)}</b><br><small class="muted">${money(Math.round(parseFloat(x.price) * 100))}</small></span></a>`)
          ].join('') || `<p class="muted" style="padding:10px">Nothing found. Try "magnet" or "birthday".</p>`;
        } catch (e) { out.innerHTML = ''; }
      }, 220);
    });
  });

  /* ---------- Accordions (FAQ etc.): smooth open and close with GSAP ---------- */
  const calm = () => reduced || document.documentElement.classList.contains('no-motion') || !window.gsap;
  $$('details.acc').forEach((d) => {
    const sum = $('summary', d), body = $('.acc__body', d); if (!sum || !body) return;
    const close = (el) => {
      const b = $('.acc__body', el);
      if (calm()) { el.open = false; return; }
      el.classList.add('is-closing');
      gsap.to(b, { height: 0, paddingBottom: 0, opacity: 0, duration: .38, ease: 'power2.inOut', overwrite: true,
        onComplete: () => { el.open = false; el.classList.remove('is-closing'); gsap.set(b, { clearProps: 'height,opacity,overflow,paddingBottom' }); } });
      gsap.set(b, { overflow: 'hidden' });
    };
    sum.addEventListener('click', (e) => {
      e.preventDefault();
      if (d.open && !d.classList.contains('is-closing')) { close(d); return; }
      // one open at a time inside the same list
      $$('details.acc[open]', d.parentElement).forEach((o) => { if (o !== d) close(o); });
      d.classList.remove('is-closing');
      d.open = true;
      if (calm()) return;
      const pb = getComputedStyle(body).paddingBottom;
      gsap.fromTo(body, { height: 0, paddingBottom: 0, opacity: 0, overflow: 'hidden' }, { height: 'auto', paddingBottom: pb, opacity: 1, duration: .5, ease: 'power3.out', overwrite: true, clearProps: 'height,overflow,paddingBottom' });
      gsap.fromTo(body.children, { y: 10, opacity: 0 }, { y: 0, opacity: 1, duration: .45, ease: 'power2.out', stagger: .05, delay: .08, clearProps: 'transform,opacity' });
    });
  });

  /* ---------- WhatsApp help popup with the Memori characters (once per visit) ---------- */
  const pop = $('[data-wa-pop]');
  if (pop) {
    const KEY = 'memori-wa-pop';
    let seen = false; try { seen = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    const mark = () => { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} };
    const hide = () => {
      mark();
      if (calm()) { pop.hidden = true; return; }
      gsap.to(pop, { y: 16, scale: .9, opacity: 0, duration: .3, ease: 'power2.in', onComplete: () => { pop.hidden = true; } });
    };
    const show = () => {
      if (seen || !pop.hidden || document.querySelector('.drawer:not([hidden])')) return;
      seen = true; mark(); pop.hidden = false;
      if (calm()) return;
      const img = $('.wa-pop__img', pop);
      gsap.fromTo(pop, { y: 24, scale: .7, opacity: 0, transformOrigin: '90% 100%' }, { y: 0, scale: 1, opacity: 1, duration: .7, ease: 'back.out(1.8)' });
      if (img) gsap.fromTo(img, { y: 20, rotate: -6 }, { y: 0, rotate: 0, duration: .9, ease: 'elastic.out(1, .5)', delay: .15 });
    };
    if (!seen) setTimeout(show, (Number(pop.dataset.delay) || 12) * 1000);
    $('[data-wa-pop-close]', pop).addEventListener('click', hide);
    $('[data-wa-pop-go]', pop).addEventListener('click', () => { mark(); pop.hidden = true; });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hidden) hide(); });
  }

  /* ---------- Real videos: load near the screen, play only while visible ---------- */
  $$('[data-rv]').forEach((v) => {
    const item = v.closest('.rv__item'), btn = item && $('[data-rv-toggle]', item);
    let userPaused = false, loaded = false;
    const still = document.documentElement.classList.contains('no-motion') || matchMedia('(prefers-reduced-motion: reduce)').matches;
    const load = () => { if (loaded) return; loaded = true; $$('source[data-src]', v).forEach((s) => { s.src = s.dataset.src; }); v.load(); };
    const setState = () => { if (item) item.classList.toggle('is-paused', v.paused); if (btn) btn.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video'); };
    v.addEventListener('play', setState); v.addEventListener('pause', setState); setState();
    if (btn) btn.addEventListener('click', () => { load(); if (v.paused) { userPaused = false; v.play().catch(() => {}); } else { userPaused = true; v.pause(); } });
    if (!('IntersectionObserver' in window)) { load(); return; }
    new IntersectionObserver(([en]) => {
      if (en.isIntersecting) { load(); if (!userPaused && !still) v.play().catch(() => {}); }
      else if (!v.paused) v.pause();
    }, { rootMargin: '200px 0px' }).observe(v);
  });

  /* ---------- Cart ---------- */
  // Add-to-cart animation: a small copy of the product photo flies into the bag icon.
  function flyToCart(from) {
    return new Promise((done) => {
      const bag = $$('[data-cart-count]').map((c) => c.closest('a, button')).find((b) => b && b.getBoundingClientRect().width > 0);
      if (!from || !bag || document.documentElement.classList.contains('no-motion') || matchMedia('(prefers-reduced-motion: reduce)').matches || !Element.prototype.animate) return done();
      const a = from.getBoundingClientRect(), b = bag.getBoundingClientRect();
      if (!a.width) return done();
      const size = Math.min(140, a.width * 0.5), src = from.currentSrc || from.src;
      const fly = document.createElement('div');
      fly.className = 'fly-cart';
      fly.style.cssText = `width:${size}px;height:${size}px;left:${a.left + a.width / 2 - size / 2}px;top:${a.top + a.height / 2 - size / 2}px;`;
      if (src) fly.style.backgroundImage = `url("${src}")`;
      document.body.appendChild(fly);
      const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
      const anim = fly.animate([
        { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1, offset: 0 },
        { transform: `translate(${dx * 0.35}px, ${dy * 0.35 - 90}px) scale(.8) rotate(-8deg)`, opacity: 1, offset: 0.45 },
        { transform: `translate(${dx}px, ${dy}px) scale(.12) rotate(6deg)`, opacity: 0.4, offset: 1 }
      ], { duration: 780, easing: 'cubic-bezier(.5,0,.3,1)' });
      anim.onfinish = () => { fly.remove(); bag.classList.remove('is-catch'); void bag.offsetWidth; bag.classList.add('is-catch'); done(); };
      setTimeout(() => { if (fly.isConnected) { fly.remove(); done(); } }, 1200);
    });
  }
  const visibleImg = (scope) => $$('img', scope).find((i) => { const r = i.getBoundingClientRect(); return r.width > 40 && r.bottom > 0 && r.top < innerHeight; });

  async function refreshCart(openAfter, added) {
    try {
      const [cart, html] = await Promise.all([
        fetch(`${R.cart_url}.js`).then((r) => r.json()),
        fetch(`${R.root_url.replace(/\/$/, '')}/?section_id=cart-drawer`).then((r) => r.text())
      ]);
      $$('[data-cart-count]').forEach((el) => { const changed = el.dataset.count != cart.item_count; el.textContent = cart.item_count; el.dataset.count = cart.item_count; if (changed && openAfter) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); } });
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#CartDrawer .drawer__panel'), cur = $('#CartDrawer .drawer__panel');
      if (fresh && added) {
        const body = $('.drawer__body', fresh), first = $('.line', fresh);
        if (body) body.insertAdjacentHTML('afterbegin', `<div class="cart-added" role="status"><span class="cart-added__tick" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span>${T('added_to_cart', 'Added to your cart')}</span></div>`);
        if (first) first.classList.add('is-new');
      }
      if (fresh && cur) cur.replaceWith(fresh);
      const page = $('[data-cart-page]');
      if (page) {
        const ph = await fetch(`${R.cart_url}?section_id=${page.dataset.sectionId}`).then((r) => r.text());
        const np = new DOMParser().parseFromString(ph, 'text/html').querySelector('[data-cart-page]');
        if (np) page.replaceWith(np);
      }
      paintEta($('#CartDrawer') || document);
      if (openAfter) openDrawer('CartDrawer');
      return cart;
    } catch (e) { location.reload(); }
  }

  document.addEventListener('click', async (e) => {
    const qb = e.target.closest('[data-line-qty]');
    if (qb) {
      e.preventDefault();
      const line = Number(qb.dataset.line), q = Math.max(0, Number(qb.dataset.lineQty));
      qb.closest('.line') && qb.closest('.line').style.setProperty('opacity', '.5');
      await fetch(`${R.cart_change_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity: q }) });
      refreshCart(false);
      return;
    }
    const up = e.target.closest('[data-upgrade]');
    if (up) {
      e.preventDefault();
      up.classList.add('is-loading');
      try {
        const props = JSON.parse(up.dataset.props || '{}');
        const r = await fetch(`${R.cart_add_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(up.dataset.upgrade), quantity: Number(up.dataset.qty || 1), properties: props }] }) });
        if (!r.ok) throw new Error();
        await fetch(`${R.cart_change_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: up.dataset.key, quantity: 0 }) });
        sfx.chime(); refreshCart(false);
      } catch (err) { up.classList.remove('is-loading'); toast(T('switch_error', "Couldn't switch it. Please try again.")); }
      return;
    }
    const ub = e.target.closest('[data-quick-add]');
    if (ub) {
      e.preventDefault();
      ub.classList.add('is-loading');
      const r = await fetch(`${R.cart_add_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(ub.dataset.quickAdd), quantity: 1 }] }) });
      ub.classList.remove('is-loading');
      if (!r.ok) { const j = await r.json().catch(() => ({})); toast(j.description || T('add_error_short', "Couldn't add that. Please try again.")); return; }
      sfx.chime();
      const card = ub.closest('.upsell, .card');
      if (card && !ub.closest('.drawer')) await flyToCart(visibleImg(card));
      refreshCart(!$('[data-cart-page]'), true);
    }
  });

  document.addEventListener('submit', (e) => {
    const f = e.target.closest('.cart-sum'); if (!f) return;
    const box = f.closest('.drawer__panel, .cart-page'), n = box && box.querySelector('[data-cart-note]');
    if (!n) return;
    let h = f.querySelector('input[name="note"]');
    if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'note'; f.appendChild(h); }
    h.value = n.value;
  });

  document.addEventListener('change', (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch(`${R.cart_update_url || '/cart/update'}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  /* ---------- Delivery estimate ---------- */
  // Words from locales/en.default.json ("js"), set in theme.liquid. [name] is filled in here.
  const T = (k, fb, vars = {}) => { let s = (M.strings && M.strings[k]) || fb; for (const [n, v] of Object.entries(vars)) s = s.split(`[${n}]`).join(v).split(`{{ ${n} }}`).join(v); return s; };
  function addWorkDays(date, n, skipSun) {
    const d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); if (!(skipSun && d.getDay() === 0)) n--; }
    return d;
  }
  const paintEta = (scope = document) => $$('[data-eta]', scope).forEach((el) => {
    const D = M.delivery || { dispatch: 1, min: 3, max: 8, cutoff: 14, skipSunday: true };
    const now = new Date();
    const offDay = D.skipSunday && now.getDay() === 0;
    const extra = now.getHours() >= D.cutoff || offDay ? 1 : 0;
    const isX = el.hasAttribute('data-eta-express'); // express delivery: made and sent the same day
    const make = isX ? 0 : D.dispatch;
    const ship = addWorkDays(now, make + extra, D.skipSunday);
    const tMin = isX && D.xmin > 0 ? D.xmin : D.min, tMax = isX && D.xmax > 0 ? Math.max(D.xmax, tMin) : D.max;
    const a = addWorkDays(ship, tMin, false), b = addWorkDays(ship, tMax, false);
    const f = (d) => d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    const out = $('[data-eta-range]', el); if (out) out.textContent = `${f(a)} – ${f(b)}`;
    const xp = $('[data-eta-xp]', el);
    if (xp && D.xmax > 0) xp.textContent = ' ' + T('arrives_by', 'Arrives by [date].', { date: f(addWorkDays(addWorkDays(now, extra, D.skipSunday), D.xmax, false)) });
    const cut = $('[data-eta-cutoff]', el);
    if (cut) {
      const end = new Date(now); end.setHours(D.cutoff, 0, 0, 0);
      const left = end - now;
      const time = `${Math.floor(left / 36e5)}h ${Math.floor(left / 6e4) % 60}m`;
      if (left > 0 && !offDay) { cut.innerHTML = isX ? T('express_in_html', '<b class="eta__cut">Order in [time]</b> and we send it today.', { time }) : T('order_in_html', '<b class="eta__cut">Order in [time]</b> and we start making it today.', { time }); cut.classList.add('is-live'); }
      else {
        const next = addWorkDays(now, 1, D.skipSunday), tmr = new Date(now); tmr.setDate(tmr.getDate() + 1);
        cut.classList.remove('is-live');
        const day = next.toLocaleDateString('en-IN', { weekday: 'long' }), isTmr = next.toDateString() === tmr.toDateString();
        cut.textContent = isX ? (isTmr ? T('express_tomorrow', 'Orders placed now are sent tomorrow.') : T('express_on', 'Orders placed now are sent on [day].', { day }))
          : (isTmr ? T('start_tomorrow', 'Orders placed now start being made tomorrow morning.') : T('start_on', 'Orders placed now start being made on [day].', { day }));
      }
    }
  });
  paintEta();

  // Pincode check: a rough estimate by region (metros fastest, far regions slowest). Labelled as an estimate.
  const initPin = (scope) => $$('[data-pin]', scope).forEach((box) => {
    const D = M.delivery || { dispatch: 1, min: 3, max: 8, cutoff: 14, skipSunday: true };
    const inp = $('[data-pin-input]', box), out = $('[data-pin-out]', box), btn = $('[data-pin-check]', box);
    const f = (d) => d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    const metro = /^(110|400|560|600|700|500|411|380|122|201)/, far = /^(18|19|78|79|737|744|6825)/;
    const check = () => {
      const pin = (inp.value || '').replace(/\D/g, '');
      inp.value = pin;
      if (!/^[1-9]\d{5}$/.test(pin)) { out.textContent = T('pin_invalid', 'Please enter a 6-digit pincode.'); out.className = 'pin__out is-bad'; return; }
      const now = new Date();
      const eta = box.closest('[data-eta]'), isX = !!(eta && eta.hasAttribute('data-eta-express'));
      const mn = isX && D.xmin > 0 ? D.xmin : D.min, mx = isX && D.xmax > 0 ? Math.max(D.xmax, mn) : D.max;
      const ship = addWorkDays(now, (isX ? 0 : D.dispatch) + (now.getHours() >= D.cutoff || (D.skipSunday && now.getDay() === 0) ? 1 : 0), D.skipSunday);
      const [lo, hi] = metro.test(pin) ? [mn, mn + 1] : far.test(pin) ? [mx, mx + 2] : [Math.round((mn + mx) / 2), mx];
      out.innerHTML = T('pin_estimate_html', 'Estimated delivery to <b>[pin]</b>: <b>[range]</b>', { pin, range: `${f(addWorkDays(ship, lo, false))} – ${f(addWorkDays(ship, hi, false))}` });
      out.className = 'pin__out is-ok';
      try { localStorage.setItem('memori:pin', pin); } catch (e) {}
    };
    btn.addEventListener('click', check);
    inp.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); check(); } });
    try { const saved = localStorage.getItem('memori:pin'); if (saved) { inp.value = saved; check(); } } catch (e) {}
  });

  initPin(document);

  /* ---------- Product ---------- */
  /* Photo prep: decode (EXIF rotation respected), cap the long side at 2000px (500 dpi on a 4 inch print), re-encode as JPEG.
     Smaller file = faster upload and a much shorter "Saving…" wait while Shopify stores it.
     Returns {blob|null, url, w, h}; blob is null when the original is already fine. null = this browser can't decode it. */
  async function prepPhoto(f) {
    try {
      let src = null, w = 0, h = 0;
      if (window.createImageBitmap) { try { src = await createImageBitmap(f, { imageOrientation: 'from-image' }); w = src.width; h = src.height; } catch (e) { src = null; } }
      if (!src) {
        const img = new Image(); img.decoding = 'async'; img.src = URL.createObjectURL(f);
        await img.decode(); src = img; w = img.naturalWidth; h = img.naturalHeight;
      }
      if (!w || !h) return null;
      const k = Math.min(1, 2000 / Math.max(w, h));
      if (k === 1 && /jpe?g|webp/i.test(f.type) && f.size < 1.2 * 1024 * 1024) return { blob: null, url: URL.createObjectURL(f), w, h };
      const c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
      const x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height); x.imageSmoothingQuality = 'high';
      x.drawImage(src, 0, 0, c.width, c.height);
      if (src.close) src.close();
      const blob = await new Promise((r) => c.toBlob(r, 'image/jpeg', 0.88));
      if (!blob) return { blob: null, url: URL.createObjectURL(f), w, h };
      return { blob, name: (f.name.replace(/\.[^.]+$/, '') || 'photo') + '.jpg', url: URL.createObjectURL(blob), w, h };
    } catch (e) { return null; }
  }
  /* Add to cart with upload progress. Retries once if the connection drops. */
  function postCart(fd, onProgress, tries = 2) {
    return new Promise((resolve, reject) => {
      const x = new XMLHttpRequest();
      x.open('POST', `${R.cart_add_url}.js`);
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest'); x.setRequestHeader('Accept', 'application/javascript');
      x.timeout = 180000;
      if (onProgress && x.upload) x.upload.onprogress = (ev) => { if (ev.lengthComputable) onProgress(Math.min(100, Math.round((ev.loaded / ev.total) * 100))); };
      x.onload = () => {
        let j = {}; try { j = JSON.parse(x.responseText); } catch (e) {}
        if (x.status >= 200 && x.status < 300 && !j.status) resolve(j);
        else reject(new Error(j.description || j.message || 'Error'));
      };
      const retry = () => (tries > 1 ? setTimeout(() => postCart(fd, onProgress, tries - 1).then(resolve, reject), 1200) : reject(new Error(T('upload_failed', "The upload didn't finish. Check your internet and try again, or send the photo on WhatsApp."))));
      x.onerror = retry; x.ontimeout = retry;
      x.send(fd);
    });
  }
  const initProduct = (scope) => $$('[data-product]', scope).forEach((root) => {
    const form = $('form[data-product-form]', root);
    const dataEl = $('script[data-variants]', root);
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const idInput = form && $('input[name="id"]', form);
    const atc = form && $('[data-atc]', form);
    const priceEl = $('[data-price]', root);
    // The "with light" product of a linked pair (or a product tagged with-light) is always lit.
    const litProduct = root.hasAttribute('data-lit-product');
    const isLitV = (v) => litProduct || litName(v && v.title);

    // Gallery
    const main = $('.gallery-main', root);
    const thumbs = $$('.gallery-thumbs button', root), dots = $$('.gallery-dots span', root);
    const goTo = (i) => { if (!main) return; main.scrollTo({ left: main.clientWidth * i, behavior: 'smooth' }); };
    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
    main && main.addEventListener('scroll', () => {
      const i = Math.round(main.scrollLeft / main.clientWidth);
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    }, { passive: true });

    // Variants
    // Values by option position (data-option-index), not page order: the Pack cards sit lower on the page than the Style cards.
    const selected = () => { const vals = variants[0] ? variants[0].options.map(() => null) : []; $$('[data-option-index]', root).forEach((g) => { const c = $('input:checked', g) || $('select', g); vals[Number(g.dataset.optionIndex)] = c ? c.value : null; }); return vals; };
    const packBox = $('[data-pack]', root), styleBox = $('[data-style-option]', root);
    const packI = packBox ? Number(packBox.dataset.optionIndex) : -1, styleI = styleBox ? Number(styleBox.dataset.optionIndex) : -1;
    const findV = (vals) => variants.find((x) => x.options.every((o, k) => vals[k] == null || o === vals[k]));
    const sameExcept = (vals, k, val) => { const c = vals.slice(); c[k] = val; return findV(c); };
    // Repaint the finish cards (+₹ difference at the chosen pack), the pack cards (price, "Save ₹…") and the light-switch note.
    function paintPrices(vals) {
      if (styleBox) {
        const opts = $$('input', styleBox).map((i) => ({ i, v: sameExcept(vals, styleI, i.value) })).filter((o) => o.v);
        const lo = Math.min(...opts.map((o) => o.v.price)), hi = Math.max(...opts.map((o) => o.v.price));
        opts.forEach(({ i, v }) => { const el = $('[data-tier-price]', i.closest('.tier') || i.parentNode); if (el) el.innerHTML = v.price > lo ? `+ ${money(v.price - lo)}<small>${T('tier_total', '[price] total', { price: money(v.price) })}</small>` : money(v.price); });
        const note = $('.lightswitch small', root); if (note && hi > lo) note.textContent = `+${money(hi - lo)}`;
      }
      if (packBox) {
        const ins = $$('input', packBox), first = ins[0], single = first && sameExcept(vals, packI, first.value), n1 = first ? Number(first.dataset.packN || 1) : 1;
        ins.forEach((i) => {
          const v = sameExcept(vals, packI, i.value), box = i.closest('.multi__opt');
          const pr = $('[data-pack-price]', box), sv = $('[data-pack-save]', box);
          if (pr) pr.textContent = v ? money(v.price) : '';
          const ea = $('[data-pack-each]', box), n = Number(i.dataset.packN || 1);
          if (ea) { ea.hidden = !(v && n > 1); ea.textContent = v && n > 1 ? T('each', '[price] each', { price: money(Math.round(v.price / n / 100) * 100) }) : ''; }
          const save = v && single ? Math.round(single.price * Number(i.dataset.packN || 1) / n1 - v.price) : 0;
          if (sv) { sv.hidden = !(save > 0); sv.textContent = save > 0 ? T('save', 'Save [amount]', { amount: money(save) }) : ''; }
          box && box.classList.toggle('is-out', !(v && v.available));
        });
      }
    }
    function update() {
      const vals = selected();
      const v = findV(vals);
      paintPrices(vals);
      // mark impossible combos
      $$('[data-option-index]', root).forEach((g) => {
        const k = Number(g.dataset.optionIndex);
        $$('input', g).forEach((inp) => {
          const ok = variants.some((x) => x.available && x.options[k] === inp.value && x.options.every((o, j) => j === k || vals[j] == null || o === vals[j]));
          const box = inp.closest('.pill, .swatch, .tier'); box && box.classList.toggle('is-out', !ok);
        });
        const lbl = $('[data-option-value]', g); if (lbl) lbl.textContent = vals[k] || '';
      });
      if (!v) { atc && (atc.disabled = true, atc.textContent = T('unavailable', 'Unavailable')); return; }
      idInput.value = v.id;
      if (priceEl) {
        priceEl.querySelector('[data-now]').textContent = money(v.price);
        const was = priceEl.querySelector('[data-was]'), save = priceEl.querySelector('[data-save]');
        const on = !priceEl.hasAttribute('data-no-sale') && v.compare_at_price && v.compare_at_price > v.price;
        if (was) { was.hidden = !on; was.textContent = on ? money(v.compare_at_price) : ''; }
        if (save) { save.hidden = !on; save.textContent = on ? `${Math.round((1 - v.price / v.compare_at_price) * 100)}% off` : ''; }
      }
      $$('[data-sticky-price]').forEach((el) => (el.textContent = money(v.price)));
      if (atc) { atc.disabled = !v.available; atc.querySelector('[data-atc-label]').textContent = v.available ? atc.dataset.label : 'Sold out'; }
      // Show the variant's photo, but never pull the shopper away from the 3D magnet: it already shows the light.
      if (v.featured_media && main && !$('[data-media-id="3d"]', main)) {
        const slide = $(`[data-media-id="${v.featured_media.id}"]`, main);
        if (slide) goTo($$('[data-media-id]', main).indexOf(slide));
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      // Light variants switch the preview glow
      const isLit = isLitV(v);
      $$('.mock-magnet, [data-mag3d]', root).forEach((m) => m.classList.toggle('is-lit', isLit));
      $$('[data-mag3d-light]', root).forEach((l) => l.setAttribute('aria-pressed', isLit));
      syncFrame(isLit);
      paintVersions(v);
      $$('[data-multi-price]', root).forEach((el) => (el.textContent = money(v.price * Number(el.dataset.multiPrice))));
      current = v; total();
    }
    // Running total: variant x quantity + ticked add-ons, shown on the button and the sticky bar.
    let current = variants.find((x) => String(x.id) === (idInput && idInput.value)) || variants[0];
    let shown = 0;
    function total() {
      if (!current) return;
      const qty = Math.max(1, Number(($('.qty input', root) || {}).value || 1));
      const sum = current.price * qty + $$('[data-addon]:checked', root).reduce((a, c) => a + Number(c.dataset.price || 0), 0);
      const els = $$('[data-total]', root).concat($$('[data-sticky-price]'));
      const paint = (c) => els.forEach((el) => (el.textContent = money(Math.round(c))));
      if (G && !reduced && shown) { const o = { v: shown }; G.to(o, { v: sum, duration: 0.5, ease: 'power3.out', onUpdate: () => paint(o.v), onComplete: () => paint(sum) }); } else paint(sum);
      shown = sum;
    }
    $$('[data-option-index] input, [data-option-index] select', root).forEach((i) => i.addEventListener('change', () => { sfx.tick(); update(); }));
    $$('[data-addon]', root).forEach((c) => c.addEventListener('change', () => { c.checked ? sfx.pop() : sfx.tick(); total(); }));
    // Express delivery tick box: the dates move earlier (made and sent the same day).
    $$('[data-express]', root).forEach((c) => {
      const eta = c.closest('[data-eta]');
      const sync = () => { if (!eta) return; eta.toggleAttribute('data-eta-express', c.checked); eta.classList.toggle('is-express', c.checked); paintEta(eta.parentNode); const pb = $('[data-pin-check]', eta), pi = $('[data-pin-input]', eta); if (pb && pi && pi.value.length === 6) pb.click(); };
      c.addEventListener('change', sync); sync();
    });
    // Light switch inside the product preview picks the matching variant.
    $$('[data-mag3d-light]', root).forEach((l) => l.addEventListener('click', () => {
      const on = l.getAttribute('aria-pressed') === 'true';
      const inp = $$('input', styleBox || root).filter((i) => !i.closest('[data-pack]') && i.closest('[data-option-index]')).find((i) => litName(i.value) === on);
      if (inp && !inp.checked) { inp.checked = true; update(); }
    }));

    // Personaliser: uploads
    $$('[data-upload]', root).forEach((field) => {
      const input = $('input[type="file"]', field), drop = $('.drop', field), thumb = $('.drop__thumb', field);
      const name = $('[data-file-name]', field), err = $('.field__error', field);
      const maxMb = Number(field.dataset.maxMb || 15);
      ['dragenter', 'dragover'].forEach((ev) => drop.addEventListener(ev, () => drop.classList.add('is-drag')));
      ['dragleave', 'drop'].forEach((ev) => drop.addEventListener(ev, () => drop.classList.remove('is-drag')));
      input.addEventListener('change', () => {
        const f = input.files && input.files[0];
        err.hidden = true; field.classList.remove('is-invalid');
        if (!f) { drop.classList.remove('has-file'); return; }
        const canShrink = f.type.startsWith('image/') && !/heic|heif/i.test(f.type) && f.size < 80 * 1024 * 1024; // shrunk on the phone before upload
        if (f.size > maxMb * 1024 * 1024 && !canShrink) {
          input.value = ''; err.textContent = T('file_too_big', 'This file is over [mb] MB. Pick a smaller one or send it on WhatsApp.', { mb: maxMb }); err.hidden = false; field.classList.add('is-invalid'); return;
        }
        drop.classList.add('has-file');
        name.textContent = f.name;
        field._blob = null; const warn = $('.field__warn', field); if (warn) warn.remove();
        const isImg = f.type.startsWith('image/') || /\.(heic|heif)$/i.test(f.name);
        if (isImg) {
          field.classList.add('is-done'); sfx.pop();
          // Shrink to print size on the phone (fast, reliable upload) and show it in the preview.
          field._ready = prepPhoto(f).then((r) => {
            const tick = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" class="icon"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
            if (!r) { // this browser can't read the format (e.g. HEIC): the original is sent as is
              thumb.innerHTML = tick;
              if (f.size > maxMb * 1024 * 1024) { input.value = ''; drop.classList.remove('has-file'); field.classList.remove('is-done'); err.textContent = T('file_too_big', 'This file is over [mb] MB. Pick a smaller one or send it on WhatsApp.', { mb: maxMb }); err.hidden = false; field.classList.add('is-invalid'); field._ready = null; }
              return;
            }
            field._blob = r.blob ? r : null;
            const url = r.url;
            thumb.innerHTML = `<img src="${url}" alt="">`;
            $$('[data-preview-photo]', root).forEach((p) => (p.style.backgroundImage = `url("${url}")`));
            $$('[data-mag3d-photo]', root).forEach((p) => { p.removeAttribute('srcset'); p.src = url; });
            if (Math.min(r.w, r.h) < 700) {
              const w = document.createElement('p'); w.className = 'field__warn';
              w.textContent = T('photo_small', 'This photo is quite small, so it may print a little soft. A bigger or original photo works best.');
              err.parentNode.insertBefore(w, err);
            }
          });
        } else {
          thumb.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" class="icon"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
        }
      });
    });

    // Personaliser: text fields + counters + live name preview
    $$('[data-text-field]', root).forEach((field) => {
      const inp = $('input, textarea', field), cnt = $('.field__count', field);
      const sync = () => {
        if (cnt) cnt.textContent = `${inp.value.length}/${inp.maxLength > 0 ? inp.maxLength : '∞'}`;
        if (field.dataset.previewName != null) $$('[data-preview-name]', root).forEach((p) => (p.textContent = inp.value || p.dataset.placeholder));
      };
      inp.addEventListener('input', sync); sync();
    });

    // Frame colour → 3D preview tint + name. Hidden (and not sent) for the lit version when set to "Without light only".
    function syncFrame(isLit) { $$('[data-frame-swatch]', root).forEach((fs) => {
      const off = fs.dataset.showFor === 'unlit' && isLit;
      fs.hidden = off; $$('input', fs).forEach((i) => (i.disabled = off));
      const c = $('input:checked', fs), nm = $('[data-frame-name]', fs);
      if (nm && c) nm.textContent = c.value;
      if (fs.dataset.frameMystery != null) { // mystery colour: the 3D preview slowly cycles through the possible frames
        clearInterval(fs._cyc); const mags = $$('.mock-magnet, [data-mag3d]', root);
        const hexes = fs.dataset.frameMystery.split(',').filter(Boolean);
        if (off || !hexes.length) { mags.forEach((m) => { m.classList.remove('has-frame'); m.style.removeProperty('--frame'); }); return; }
        let k = 0; const paint = () => mags.forEach((m) => { m.classList.add('has-frame'); m.style.setProperty('--frame', hexes[k++ % hexes.length]); });
        paint(); if (!matchMedia('(prefers-reduced-motion: reduce)').matches) fs._cyc = setInterval(paint, 1800);
        return;
      }
      $$('.mock-magnet, [data-mag3d]', root).forEach((m) => {
        if (off || !c || !c.dataset.color) { m.classList.remove('has-frame'); m.style.removeProperty('--frame'); }
        else { m.classList.add('has-frame'); m.style.setProperty('--frame', c.dataset.color); }
      });
    }); }
    $$('[data-frame-swatch] input', root).forEach((i) => i.addEventListener('change', () => syncFrame(isLitV(current))));
    syncFrame(isLitV(current));

    // Light versions (two linked products): keep the links on the same pack, and carry the photo and text across.
    function paintVersions(v) {
      if (!v) return;
      let other = null;
      $$('[data-version]', root).forEach((a) => {
        let m = {}; try { m = JSON.parse(a.dataset.map || '{}'); } catch (e) {}
        const e = m[v.title]; if (!e) return;
        const u = new URL(a.dataset.url, location.href); u.searchParams.set('variant', e[0]); a.href = u.pathname + u.search;
        const p = $('[data-version-price]', a); if (p) p.textContent = money(e[1]);
        if (!a.hasAttribute('aria-current')) other = { href: a.href, price: e[1] };
      });
      $$('[data-version-switch]', root).forEach((s) => {
        if (!other) return; s.href = other.href;
        const n = $('small', s); if (n) n.textContent = !isLitV(v) && other.price > v.price ? `+${money(other.price - v.price)}` : '';
      });
    }
    paintVersions(current);
    const carryDb = () => new Promise((res, rej) => { const r = indexedDB.open('memori', 1); r.onupgradeneeded = () => r.result.createObjectStore('kv'); r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error); });
    const fieldsOf = () => $$('input[name^="properties["], textarea[name^="properties["]', root).filter((i) => !i.closest('[data-frame-swatch]') && i.type !== 'hidden' && i.type !== 'radio' && i.type !== 'checkbox');
    $$('[data-version]:not([aria-current]), [data-version-switch]', root).forEach((a) => a.addEventListener('click', async (e) => {
      const data = { t: Date.now(), f: {} };
      fieldsOf().forEach((i) => { if (i.type === 'file') { if (i.files && i.files[0]) data.f[i.name] = i.files[0]; } else if (i.value) data.f[i.name] = i.value; });
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      if (Object.keys(data.f).length && window.indexedDB) {
        try { const db = await carryDb(); await new Promise((r) => { const tx = db.transaction('kv', 'readwrite'); tx.objectStore('kv').put(data, 'carry'); tx.oncomplete = r; tx.onerror = r; }); } catch (err) {}
      }
      swapProduct(a.href);
    }));
    if ($('[data-versions], [data-version-switch]', root) && window.indexedDB) {
      carryDb().then((db) => {
        const tx = db.transaction('kv', 'readwrite'), st = tx.objectStore('kv'), g = st.get('carry');
        g.onsuccess = () => {
          const d = g.result; st.delete('carry');
          if (!d || Date.now() - d.t > 15 * 60 * 1000) return;
          fieldsOf().forEach((i) => {
            const val = d.f[i.name]; if (val == null) return;
            if (i.type === 'file') { try { const dt = new DataTransfer(); dt.items.add(val); i.files = dt.files; i.dispatchEvent(new Event('change', { bubbles: true })); } catch (err) {} }
            else { i.value = val; i.dispatchEvent(new Event('input', { bubbles: true })); }
          });
        };
      }).catch(() => {});
    }

    // Quantity
    const syncMulti = (n) => $$('[data-multi-qty]', root).forEach((r) => (r.checked = Number(r.value) === n));
    $$('.qty', root).forEach((q) => {
      const inp = $('input', q);
      $$('button', q).forEach((b) => b.addEventListener('click', () => { inp.value = Math.max(1, Number(inp.value) + Number(b.dataset.step)); syncMulti(Number(inp.value)); sfx.tick(); total(); }));
      inp.addEventListener('change', () => { syncMulti(Number(inp.value)); total(); });
    });
    // "How many?" cards drive the quantity box.
    $$('[data-multi-qty]', root).forEach((r) => r.addEventListener('change', () => {
      const q = $('.qty input', root); if (q) q.value = r.value;
      sfx.tick(); total();
    }));

    // Submit
    form && form.addEventListener('submit', async (e) => {
      // Required personalisation check
      let bad = null;
      $$('[data-required]', form).forEach((field) => {
        const inp = $('input, textarea, select', field);
        const empty = inp.type === 'file' ? !(inp.files && inp.files.length) : !inp.value.trim();
        const err = $('.field__error', field);
        field.classList.toggle('is-invalid', empty);
        if (err) { err.hidden = !empty; if (empty) err.textContent = field.dataset.requiredMsg || T('required', 'Please fill this in.'); }
        if (empty && !bad) bad = field;
      });
      if (bad) { e.preventDefault(); bad.scrollIntoView({ behavior: 'smooth', block: 'center' }); const i = $('input, textarea', bad); i && i.focus({ preventScroll: true }); return; }
      if (!window.fetch || !window.FormData) return; // old browsers: normal submit (add-ons are skipped)
      e.preventDefault();
      if (atc.classList.contains('is-loading') || atc.classList.contains('is-uploading')) return;
      atc.classList.add('is-loading');
      try {
        const ups = $$('[data-upload]', form);
        await Promise.all(ups.map((u) => u._ready || 0));
        const fd = new FormData(form);
        let hasFile = false;
        ups.forEach((u) => {
          const i = $('input[type="file"]', u);
          if (!i || !i.files || !i.files.length) return;
          hasFile = true;
          if (u._blob) fd.set(i.name, u._blob.blob, u._blob.name);
        });
        const lab0 = $('[data-atc-label]', atc), was0 = lab0 ? lab0.textContent : '';
        if (hasFile) { atc.classList.remove('is-loading'); atc.classList.add('is-uploading'); atc.style.setProperty('--up', '0%'); if (lab0) lab0.textContent = T('uploading', 'Uploading photo…'); }
        const xpBox = $('[data-express][data-addon]:checked', root);
        const xpCart = xpBox ? fetch(`${R.cart_url}.js`).then((r) => r.json()).catch(() => null) : null; // checked while the photo uploads
        try {
          await postCart(fd, hasFile ? (p) => { atc.style.setProperty('--up', p + '%'); if (lab0) lab0.textContent = p < 100 ? T('uploading_pct', 'Uploading photo [p]%', { p }) : T('saving', 'Saving…'); } : null);
        } finally {
          if (hasFile) { atc.classList.remove('is-uploading'); atc.style.removeProperty('--up'); if (lab0) lab0.textContent = was0; atc.classList.add('is-loading'); }
        }
        let addons = $$('[data-addon]:checked', root).map((c) => ({ id: Number(c.value), quantity: 1 }));
        if (xpBox) { // one express delivery per order
          const c = await xpCart;
          if (c && c.items.some((i) => i.variant_id === Number(xpBox.value))) addons = addons.filter((a) => a.id !== Number(xpBox.value));
        }
        if (addons.length) await fetch(`${R.cart_add_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: addons }) });
        if (xpBox) { xpBox.disabled = true; xpBox.removeAttribute('data-addon'); const sm = $('.eta__opt-txt small', xpBox.closest('.eta__opt')); if (sm) sm.textContent = T('express_in_cart', 'Express delivery is already in your cart.'); xpBox.closest('.eta__opt').classList.add('is-in-cart'); total(); }
        if (M.cartType === 'page') { location.href = R.cart_url; return; }
        sfx.chime();
        const lab = $('[data-atc-label]', atc), was = lab ? lab.textContent : '';
        atc.classList.remove('is-loading'); atc.classList.add('is-added');
        if (lab) lab.textContent = T('added', 'Added');
        setTimeout(() => { atc.classList.remove('is-added'); if (lab) lab.textContent = was; }, 2200);
        const pic = $('.mag3d__face img', root) || visibleImg($('.pdp__gallery', root) || root);
        await Promise.all([flyToCart(pic), new Promise((r) => setTimeout(r, 120))]);
        await refreshCart(true, true);
      } catch (err) {
        toast(err.message && err.message !== 'Error' ? err.message : T('add_error', "Couldn't add to cart. Try again or message us on WhatsApp."));
      } finally { atc.classList.remove('is-loading'); }
    });

    // Sticky ATC on phones
    const sticky = $('[data-sticky-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-atc');
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(atc);
      $('button', sticky).addEventListener('click', () => {
        const firstReq = $$('[data-required]', form).find((f) => { const i = $('input, textarea', f); return i && (i.type === 'file' ? !(i.files && i.files.length) : !i.value.trim()); });
        (firstReq || atc).scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (!firstReq) atc.click();
      });
    }
    total();
  });
  initProduct(document);

  /* Light versions are two linked products. Switch between them in place (no full page reload):
     fetch the other product page, swap the product section, re-run its scripts, update the URL. */
  let swapped = false;
  function swapProduct(url, push = true) {
    const cur = document.querySelector('[data-product]'); const sec = cur && (cur.closest('.shopify-section') || cur);
    if (!sec || !window.fetch || !window.DOMParser) { location.href = url; return; }
    sec.classList.add('is-swapping');
    fetch(url, { credentials: 'same-origin' }).then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); }).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const np = doc.querySelector('[data-product]'); const nsec = np && (np.closest('.shopify-section') || np);
      if (!nsec) throw new Error('no product');
      const node = document.importNode(nsec, true);
      sec.replaceWith(node);
      if (doc.title) document.title = doc.title;
      if (push) history.pushState({ memoriSwap: 1 }, '', url);
      swapped = true;
      initMag3d(node); initPin(node); paintEta(node); initProduct(node);
      node.querySelectorAll('.reveal, [class*="reveal"]').forEach((e) => e.classList.add('is-in', 'is-visible'));
    }).catch(() => { location.href = url; });
  }
  addEventListener('popstate', () => { if (swapped) swapProduct(location.href, false); });

  /* ---------- Collection: auto-submit filters ---------- */
  $$('[data-facets]').forEach((f) => f.addEventListener('change', (e) => { if (e.target.matches('input[type="checkbox"], select')) f.requestSubmit ? f.requestSubmit() : f.submit(); }));
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u; }));

  /* ---------- Track order: order number → WhatsApp chat with a ready message ---------- */
  // Without JS the form still opens WhatsApp with just the number as the message.
  $$('[data-track-wa]').forEach((f) => f.addEventListener('submit', (e) => {
    const inp = $('input[name="text"]', f), n = inp.value.replace(/[^0-9A-Za-z-]/g, '');
    e.preventDefault();
    const msg = n ? (f.dataset.msg || '[order]').replace('[order]', n) : (f.dataset.msg || '').replace(/\s*#?\[order\]/, '');
    const a = Object.assign(document.createElement('a'), { href: `${f.action}?text=${encodeURIComponent(msg)}`, target: '_blank', rel: 'noopener' });
    a.click();
  }));

  /* ---------- WhatsApp peek ---------- */
  const wa = $('.wa-float');
  if (wa) setTimeout(() => { wa.classList.add('is-peek'); setTimeout(() => wa.classList.remove('is-peek'), 5000); }, 6000);
})();

/* Card hover photos: fetch them quietly after the page loads, so the hover crossfade never waits for a download. */
(() => {
  const warm = () => document.querySelectorAll('img.card__img2[loading="lazy"]').forEach((i) => { i.loading = 'eager'; i.decoding = 'async'; });
  const idle = window.requestIdleCallback || ((f) => setTimeout(f, 600));
  if (document.readyState === 'complete') idle(warm); else addEventListener('load', () => idle(warm));
  document.addEventListener('pointerover', (e) => { const c = e.target.closest && e.target.closest('.card'); const i = c && c.querySelector('img.card__img2[loading="lazy"]'); if (i) i.loading = 'eager'; }, { passive: true });
})();

/* Smooth scrolling (computers): Lenis on the GSAP clock. Phones keep native scrolling. Off for reduced motion. */
(() => {
  const go = () => {
    if (!window.Lenis || matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify && Shopify.designMode) return;
    const lenis = new Lenis({ lerp: 0.24, smoothWheel: true, wheelMultiplier: 1, anchors: { offset: -80 }, autoRaf: !window.gsap,
      prevent: (n) => !!(n.closest && n.closest('.drawer, [role="dialog"], dialog, .wa-pop, [data-lenis-prevent], .pgrid__chips, .dw__rail, .rv__grid')) });
    if (window.gsap) { gsap.ticker.add((t) => lenis.raf(t * 1000)); gsap.ticker.lagSmoothing(0); }
    window.memoriLenis = lenis;
    // Pause while a drawer or menu locks the page.
    const sync = () => (document.body.classList.contains('is-locked') ? lenis.stop() : lenis.start());
    new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    // Route the theme's smooth scrollIntoView calls through Lenis so they don't fight.
    const native = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function (o) {
      if (o && typeof o === 'object' && o.behavior === 'smooth' && !document.body.classList.contains('is-locked')) {
        const r = this.getBoundingClientRect();
        const off = o.block === 'center' ? -(innerHeight - Math.min(r.height, innerHeight)) / 2 : -90;
        lenis.scrollTo(this, { offset: off, duration: 0.7 }); return;
      }
      return native.call(this, o);
    };
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* Diwali band: word-by-word heading, diyas light in turn, designs glow on in turn, soft fireworks while visible. */
(() => {
  const band = document.querySelector('[data-dw]'); if (!band) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;
  const h = band.querySelector('.dw__title');
  if (h && !h.dataset.split) {
    h.dataset.split = '1';
    const words = h.textContent.trim().split(/\s+/);
    h.setAttribute('aria-label', h.textContent.trim());
    h.innerHTML = words.map((w, i) => `<span class="dw__w" aria-hidden="true" style="--w:${i}">${w.replace(/&/g, '&amp;').replace(/</g, '&lt;')}</span>`).join(' ');
  }
  const head = band.querySelector('.dw__head') || band;
  band.classList.add('dw--armed');
  let played = false;
  const play = () => { if (played) return; played = true; requestAnimationFrame(() => band.classList.add('dw--play')); };
  const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { play(); io.disconnect(); } }, { rootMargin: '0px 0px -30% 0px' }); io.observe(head);
  // safety net: if the heading is clearly on screen and the observer missed it, show everything
  const net = () => { const r = head.getBoundingClientRect(); if (r.top < innerHeight * 0.7 && r.bottom > 0) play(); };
  addEventListener('scroll', () => { if (!played) setTimeout(net, 300); }, { passive: true });

  // Fireworks
  const cv = band.querySelector('[data-dw-fx]'); if (!cv || !cv.getContext) return;
  const x = cv.getContext('2d'); let W = 0, H = 0, dpr = 1, on = false, raf = 0, next = 0; const P = [];
  const size = () => { dpr = Math.min(devicePixelRatio || 1, 1.5); W = band.clientWidth; H = band.clientHeight; cv.width = W * dpr; cv.height = H * dpr; x.setTransform(dpr, 0, 0, dpr, 0, 0); };
  const COLS = ['255,210,122', '255,159,67', '255,120,140', '255,244,224', '255,196,82'];
  const burst = () => {
    const narrow = W < 750;
    const side = Math.random() < 0.5;
    const bx = narrow ? W * (0.12 + Math.random() * 0.76) : (side ? W * (0.05 + Math.random() * 0.2) : W * (0.75 + Math.random() * 0.2));
    const by = H * (narrow ? 0.06 + Math.random() * 0.12 : 0.1 + Math.random() * 0.28);
    const c = COLS[(Math.random() * COLS.length) | 0], n = narrow ? 34 : 46;
    for (let i = 0; i < n; i++) { const a = (i / n) * Math.PI * 2 + Math.random() * 0.2, sp = 1.2 + Math.random() * 2.2; P.push({ x: bx, y: by, px: bx, py: by, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, l: 0, m: 55 + Math.random() * 35, c }); }
  };
  const tick = (t) => {
    if (!on) return;
    if (t > next) { burst(); next = t + 1300 + Math.random() * 1500; }
    x.clearRect(0, 0, W, H); x.lineCap = 'round';
    for (let i = P.length - 1; i >= 0; i--) {
      const p = P[i]; p.px = p.x; p.py = p.y; p.vx *= 0.975; p.vy = p.vy * 0.975 + 0.035; p.x += p.vx; p.y += p.vy; p.l++;
      const a = 1 - p.l / p.m; if (a <= 0) { P.splice(i, 1); continue; }
      x.strokeStyle = `rgba(${p.c},${a})`; x.lineWidth = 1.6; x.beginPath(); x.moveTo(p.px - p.vx * 2, p.py - p.vy * 2); x.lineTo(p.x, p.y); x.stroke();
    }
    raf = requestAnimationFrame(tick);
  };
  const start = () => { if (on || document.hidden) return; on = true; size(); next = performance.now() + 900; raf = requestAnimationFrame(tick); };
  const stop = () => { on = false; cancelAnimationFrame(raf); P.length = 0; x.clearRect(0, 0, W, H); };
  new IntersectionObserver(([e]) => (e.isIntersecting ? start() : stop())).observe(band);
  document.addEventListener('visibilitychange', () => (document.hidden ? stop() : (band.getBoundingClientRect().bottom > 0 && band.getBoundingClientRect().top < innerHeight && start())));
  addEventListener('resize', () => on && size(), { passive: true });
})();
